import { render, staticRenderFns } from "./TheEditItemView.vue?vue&type=template&id=f0deba10&scoped=true"
import script from "./TheEditItemView.vue?vue&type=script&lang=js"
export * from "./TheEditItemView.vue?vue&type=script&lang=js"
import style0 from "./TheEditItemView.vue?vue&type=style&index=0&id=f0deba10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0deba10",
  null
  
)

export default component.exports